import { render } from "./ListFacturesPage.vue?vue&type=template&id=e6a6b96e&scoped=true&ts=true"
import script from "./ListFacturesPage.vue?vue&type=script&lang=ts"
export * from "./ListFacturesPage.vue?vue&type=script&lang=ts"

import "./ListFacturesPage.vue?vue&type=style&index=0&id=e6a6b96e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6a6b96e"]])

export default __exports__